export const styles = {
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'gray.0',
    width: '100%',
  },

  companyButton: {
    display: 'flex',
    alignItems: 'center',
    height: '64px',
    width: '100%',
    padding: '12px 16px',
    border: 'none',
  },

  companyIcon: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    flexShrink: 0,
  },

  companyIconPlaceholder: {
    backgroundColor: 'primary.lightest',
    color: 'primary.main',
    fontSize: '0.875rem',
    fontWeight: 600,
  },

  companyName: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: 'gray.80',
    marginLeft: '12px',
    flex: 1,
    textAlign: 'left',
  },

  locationButton: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '48px',
    width: '100%',
    padding: '12px 16px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    border: 'none',
    gap: '12px',
    '&:hover': {
      backgroundColor: 'primary.lightest',
    },
  },

  locationIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
  },

  locationIcon: {
    color: 'primary.main',
    fontSize: '20px',
    width: '20px',
    height: '20px',
  },

  locationText: {
    color: 'gray.80',
    flex: 1,
    textAlign: 'left',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '20px',
  },
}
